export default {
	orderTypes: state => {
		return state.orderTypes;
	},
	maturityTypes: state => {
		return state.maturityTypes;
	},
	tradeTypes: state => {
		return state.tradeTypes;
	},
	cashBalance: state => {
		return state.cashBalance;
	},
	accountShareBalance: state => {
		return state.accountShareBalance;
	}
};
